import { Radio, RadioProps } from "@mui/material";

export default function CustomRadio(props: RadioProps) {
    return (
        <Radio
            sx={{
                border: "#0082DE",
                color: "#0082DE",
                "&.Mui-checked": {
                    color: "#0082DE",
                },
            }}
            {...props}
        />
    );
}
